import React from 'react';
import './App.css';
import Header from './component/Header';
import Headerpart1 from './component/Headerpart1';
import Dflex from './component/Dflex';
import Myexperience from './component/Myexperience';
import Aboutme from './component/Aboutme';
import Project from './component/Project';
import Client from './component/Client';
import Footerform from './component/Footerform';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBehance } from '@fortawesome/free-brands-svg-icons';


function App() {
  return (
    <div className="App">
      <Header/>
      <Headerpart1/>
<Dflex/>
<Myexperience/>
<Aboutme/>
<Project/>
<Client/>
<Footerform/>
    </div>
  );
}
export default App;
